import React from "react";
import {registerBlockType} from "@wordpress/blocks";
import apiFetch from "@wordpress/api-fetch";
import { Fragment } from "@wordpress/element";
import {RichText} from "@wordpress/block-editor";
import {PanelBody,Panel,RangeControl,SelectControl,TextControl,Button} from "@wordpress/components";
import {
    useBlockProps,
    ColorPalette,
    InspectorControls,
    InnerBlocks,
    BlockControls,
    AlignmentToolbar,
    MediaUpload,
    MediaUploadCheck,
    __experimentalLinkControl as LinkControl
} from '@wordpress/block-editor';

registerBlockType("template-scripts/press-releases",{
  "title":"Press Releases",
  "icon":"button",
  attributes:{
    numShow:{type:'number',default:4},
    category:{type:'number',default:0}
  },

  edit({attributes,setAttributes}){
    const [categories,setCategories] = React.useState([]);

    React.useEffect(()=>{
      apiFetch({path:'/wp/v2/categories'}).then((data)=>{
        setCategories(data);
      });
    },[]);

    const articleComponents = new Array(attributes.numShow ? attributes.numShow : 4).fill("").map((i,k)=>{
      return (<div key={`article${k}`} className="col">
        <div className="item">
          <div style={{display:"block",width:"100%",height:"120px",backgroundColor:"#666",marginBottom:"10px"}}></div>
          <div style={{display:"block",width:"100%",height:"25px",backgroundColor:"#666",marginBottom:"5px"}}></div>
          <div style={{display:"block",width:"90%",height:"25px",backgroundColor:"#666",marginBottom:"5px"}}></div>
        </div>
      </div>)
    })

    return (<>
    <BlockControls/>
    <InspectorControls>
      <Panel>
        <PanelBody title="Category">
          <SelectControl 
            options={[{value:0,label:"All Categories"},...categories.map(c=>({value:c.id,label:c.name}))]}
            value={attributes.category}
            onChange={(v)=>setAttributes({category:v})}
          />
        </PanelBody>
        <PanelBody title="Number of Articles">
          <RangeControl 
            min={1}
            max={20}
            value={attributes.numShow}
            onChange={(v)=>setAttributes({numShow:v})}
          />
        </PanelBody>
      </Panel>
    </InspectorControls>

      
      <div {...useBlockProps()}>
        <div className="pressreleases">
          <div className="scroll">
            {articleComponents}
          </div>
        </div>
      </div>
    </>);
  },
  save(){
    return (<></>);
  }
});
